









































































import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class ProjectLogComponet extends Vue {
  project = this.$store.state.project;
  application = this.$store.state.application;

  created() {
    this.loadLog();
  }

  get logItems(): [] {
    return this.$store.getters['project/getLogItems']();
  }

  get totalCount(): [] {
    return this.$store.getters['project/getLogItemsCount']();
  }

  loadLog(): void {
    const searchQuery = this.project.projectLog.search;
    const projectId = this.project.detail.id;

    this.$store.dispatch('project/getLog', { projectId, searchQuery });
  }

  onPage(page: number): void {
    this.project.projectLog.search.actualPage = page;
    this.loadLog();
  }
  onSort(field: any): void {
    this.project.projectLog.search.orderBy = field[0];
    this.loadLog();
  }
  onSortDesc(desc: any): void {
    this.project.projectLog.search.orderByAsc = !desc[0];
    this.loadLog();
  }
  onItemsPerPage(field: any): void {
    this.project.projectLog.search.pageRows = field === -1 ? this.project.projectLog.totalCount : field;
    this.loadLog();
  }

  expanded = [];
  get headers() {
    return [
      { text: this.$t('log.createdOn'), value: 'createdOn' },
      { text: this.$t('log.userName'), value: 'userName' },
      { text: this.$t('log.firstName'), value: 'firstName' },
      { text: this.$t('log.lastName'), value: 'lastName' },
      { text: '', value: 'data-table-expand' }
    ];
  }
}
